import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'

export default {
	name: 'shippingDetails',
	components: {
		Paginate,
		Loader
	},
	data: function() {
		return {
			currentPage: 0,
			updateShippingmodal: false,
			length: '',
			height: '',
			updateShipping: '',
			isLoading: false,
			resultCount: '',
			userid: '',
			clientId: '',
			orderid: '',
			warehouseid: '',
			boxid: '',
			transporter: '',
			correctAWB: '',
			transporterList: [],
			listShipmentData: [],
			editshipping: {
				boxid: '',
				orderid: '',
				transporter: '',
				correctAWB: ''
			},
			pageno: 0,
			pageCount: 0,
			pageLimit: 10
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userid = userdetail.userid;
		this.warehouseid = userdetail.warehouseid;
		this.pageno = 0;
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getTransporterList()
		}
	},
	methods: {

		checkboxid() {
			var reg = new RegExp('^[0-9]+\d*$')
			var result = reg.test(this.boxid)
			if (result == false) {
				this.boxid = '';
				document.getElementById("boxid").value = '';
				this.$alertify.error( this.$t('ShippingDetails.numericBoxID') );
				return false;
			} else if (this.boxid == 0) {
				this.boxid = '';
				document.getElementById("boxid").value = '';
				this.$alertify.error(this.$t('ShippingDetails.boxIDgreaterThanZero'));
				return false;
			} else if (this.boxid > 9999999999) {
				this.boxid = '';
				document.getElementById("boxid").value = '';
				this.$alertify.error(this.$t('ShippingDetails.BoxID10Digits'));
				return false;
			}
		},


		getShipmentDetailsList() {
			if (this.orderid == '' && this.boxid == '') {
				this.$alertify.error(this.$t('ShippingDetails.enterBoxOrOrderID'));
				return false;
			}
			this.listShipmentData = [];
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'orderid': this.orderid.trim(),
				'boxid': this.boxid.trim(),
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getDetailsBoxId',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					this.listShipmentData = result.data.data;
					if (result.data.errorCode == -1) {
						this.$alertify.error(result.data.msg);
						this.resultCount = 0;
					} else {
						this.clientId = result.data.clientid
						this.resultCount = result.data.count

					}
				}, error => {
					console.error(error);
				})
		},
		UpdateShippingDetails() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'orderid': this.editshipping.orderid,
				'boxid': this.editshipping.boxid,
				'awbno': this.editshipping.correctAWB,
				'transporter': this.editshipping.transporter,
				'clientid': this.clientId
			});
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateDetailsBoxId',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.errorCode == 0) {
						this.$alertify.success(result.data.msg);
						this.updateShippingmodal = false;
						this.getShipmentDetailsList();
					} else {
						this.$alertify.error(result.data.msg)
					}
				}, error => {
					console.error(error);
				})
		},
		getTransporterList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				warehouseid: this.warehouseid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'courierMasterList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.transporterList = result.data.data.rows;
				}, error => {
					console.error(error)
				})
		},
		UpdateShipping(data) {
			this.updateShippingmodal = true;
			this.$validator.reset();
			this.errors.clear();
			this.editshipping = data;
			this.editshipping.orderid = data.orderid;
			this.editshipping.boxid = data.boxid;
			this.editshipping.transporter = data.shippingcompany;
			this.editshipping.correctAWB = data.awbno;
		},
		closeupdateShippingmodal() {
			this.updateShippingmodal = false;
		},

		resetFormData() {
			this.boxid = '';
			this.orderid = '';
			this.transporter = '';
			this.correctAWB = '';
			this.transporterList = [];
			this.listShipmentData = [];
			this.resultCount = 0;
		},
		onSubmit() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
					console.log('form is valid', this.model)
					this.UpdateShippingDetails()
				}

			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/shippingDetails/shippingDetails.component.js